import React from 'react';

import './index.scss';
import { buildClassNames } from '../../utils';

export const Card: React.FC<React.ComponentProps<'div'>> = ({ className, ...props }) => {
  const classNames = buildClassNames('chron__card', className);
  return <div className={classNames} {...props} />;
};
